import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice"
import modelConfigsReducer from "./slices/modelSlice"
import modelSettingsReducer from "../modules/chat/slices/modelSettingsSlice"
import chatDeptReducer from "../modules/chat/slices/chatDeptSlice"
import workflowDeptReducer from "../modules/workflows/slices/workflowDeptSlice"
import translationReducer from "./slices/translationSlice"
import appInfoReducer from "./slices/appInfoSlice"
import kbReducer from "../modules/chat/slices/kbSlice"
import scopeReducer from "../modules/chat/slices/scopeSlice"
import kbFilesReducer from "../modules/chat/slices/kbFilesSlice"
import kbManageReducer from "../modules/chat/slices/kbManageSlice"
import conversationReducer from "../modules/chat/slices/conversationSlice"
import responseToolReducer from "../modules/chat/slices/responseToolSlice"
import chatInputReducer from "../modules/chat/slices/chatInputSlice"
import savedChatReducer from "../modules/chat/slices/savedChatSlice"
import internetSearchReducer from "../modules/chat/slices/internetSearchSettingsSlice"
import presentationReducer from "../modules/chat/slices/presentationSlice"
import artifactsReducer from "../modules/workflows/slices/artifactsSlice"
import artifactsConfigReducer from "../modules/workflows/slices/artifactsConfigSlice"
import toolsConfigReducer from "../modules/workflows/slices/toolConfigSlice"

export const store = configureStore({
    reducer: {
        user: userReducer,
        modelConfigs: modelConfigsReducer,
        modelSettings: modelSettingsReducer,
        appInfo: appInfoReducer,
        scope: scopeReducer,
        chatDept: chatDeptReducer,
        workflowDept: workflowDeptReducer,
        translationLanguages: translationReducer,
        presentation: presentationReducer,
        knowledgeBase: kbReducer,
        kbFiles: kbFilesReducer,
        kbManage: kbManageReducer,
        conversation: conversationReducer,
        responseTool: responseToolReducer,
        chatInput: chatInputReducer,
        internetSearchSettings: internetSearchReducer,
        artifacts: artifactsReducer,
        artifactsConfig: artifactsConfigReducer,
        artifactsToolsConfig: toolsConfigReducer,
        savedChat: savedChatReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch